import script from "./Benefits.vue?vue&type=script&setup=true&lang=js"
export * from "./Benefits.vue?vue&type=script&setup=true&lang=js"

import "./Benefits.vue?vue&type=style&index=0&id=fa41959c&lang=scss"

const __exports__ = script;

export default __exports__